/**
* 系统管理 系统环境变量
*/
<template>
	<div>
		<!-- 面包屑导航 -->
		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column prop="title" label="标题" width="200" align="center">
			</el-table-column>
			<el-table-column prop="des" label="内容" width="600" align="center">
			</el-table-column>
			<el-table-column prop="background" label="图片" width="200" align="center">
				<template slot-scope="scope">
					<img style="width: 100%; height: auto;" :src="imgh+'schooladimg_' + scope.row.id + '_0.png'" />
				</template>
			</el-table-column>
			<el-table-column align="center" label="操作" min-width="50">
				<template slot-scope="scope">
					<el-button size="mini" type="danger" @click="deletePoster(scope.$index)">删除</el-button>
					<el-button size="mini" type="primary" @click="handleEdit(scope.$index)">编辑</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-button type="primary" @click="handleEdit(-1)">添加公告</el-button>
		<el-button type="info" @click="updateInfo()">更新首页通知</el-button>
		<!-- 编辑界面 -->
		<el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
			<el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
				<el-form-item label="标题" prop="title">
					<el-input size="small" v-model="editForm.title" auto-complete="off" placeholder="请输入公告标题" />
				</el-form-item>
				<el-form-item label="内容" prop="des">
					<el-input size="small" type="textarea" v-model="editForm.des" placeholder="请输入工作详情" />
				</el-form-item>
				<el-form-item v-if="theindex!=-1" label="详情图" prop="urls">
					<div class="main-block">
						<el-upload multiple action="#" :before-upload="(file) => {return beforeUpload_zhutu(file)}"
							accept=".png,.jpg,.gif" :multiple="true">
							<a :hidden="editForm.zimg.length!=0" class="iconfont icon-addimg add-img-icon" />
							<el-image class="main-img" v-for="iem in editForm.zimg" fit="contain" :src="iem.url"
								alt="" />
						</el-upload>
						<a class="iconfont icon-clean clean-img-icon" @click="deleteTheImg(0)" />
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click='closeDialog("edit")'>取消</el-button>
				<el-button size="small" type="primary" :loading="loading" class="title"
					@click="submitForm('editForm')">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		GetSchoolAdList,
		SubmitTheSchoolAd,
		PictureServer,
		uploadFile,
		deleteImg,
		DeleteTheSchoolAd,
		UpdateTheHomeInfo
	} from '../../api/userMG'
	export default {
		data() {
			return {
				editFormVisible: false,
				loading: false, //是显示加载
				title: '添加',
				// 编辑与添加
				editForm: {
					des: '',
					title: '',
					zimg: []
				},
				// rules表单验证
				rules: {
					title: [{
						required: true,
						message: '请输入标题',
						trigger: 'blur'
					}],
					des: [{
						required: true,
						message: '请填写内容',
						trigger: 'blur'
					}]
				},
				listData: [], //用户数据
				imgh: PictureServer.Info
			}
		},
		created() {
			this.loading = true
			GetSchoolAdList().then(res => {
				var img
				for (var i = 0; i < res.length; i++) {
					img = []
					for (var k = 0; k < res[i][3]; k++) {
						img.push({
							url: PictureServer.Info + 'schooladimg_' + res[i][0] + '_' + k + '.png'
						})
					}
					this.listData.unshift({
						id: res[i][0],
						title: res[i][1],
						des: res[i][2],
						img: img
					})
				}
				this.loading = false
			})
		},

		methods: {
			//显示编辑界面
			handleEdit: function(index) {
				if (index == -1) {
					this.title = '添加首页公告'
					this.editForm.title = ''
					this.editForm.des = ''
					this.editForm.zimg = []
					this.znums = 0
				} else {
					this.title = '修改内容'
					this.editForm.title = this.listData[index].title
					this.editForm.des = this.listData[index].des
					this.editForm.zimg = this.listData[index].img
					this.znums = this.editForm.zimg.length
				}
				this.theindex = index
				this.editFormVisible = true

			},
			deletePoster(index) {
				this.$confirm('确定要删除吗?', '信息', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					DeleteTheSchoolAd(this.listData[index].id).then(res => {
						if (res) {
							this.$message({
								type: 'success',
								message: '已删除!'
							})
							this.listData.splice(index, 1)
							this.loading = false
						}
					})
				})
			},
			beforeUpload_zhutu(file) {
				var filen = 'schooladimg_' + this.listData[this.theindex].id + '_' + this.znums + '.png'
				this.znums++
				setTimeout(r => {
					uploadFile(file, filen).then(res => {
						this.editForm.zimg.push({
							url: PictureServer.Info + filen + '?rnd=' + Math.random()
						})
					})
					return false;
				}, this.znums * 200)
			},
			deleteTheImg() {
				this.$confirm('确定删除图片吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					for (var k = 0; k < this.editForm.zimg.length; k++) {
						deleteImg('schooladimg_' + this.listData[this.theindex].id + '_' + k + '.png')
					}
					this.editForm.zimg = []
					this.znums = 0
					this.$message.success('该工作主图已全部删除');
				})
			},
			// 编辑、添加提交方法
			submitForm(editData) {
				this.$refs[editData].validate(valid => {
					if (valid) {
						if (this.theindex == -1) {
							var pa = {
								c: this.editForm.title,
								k: this.editForm.des,
								i: this.editForm.zimg.length,
								id: 0
							}
						} else {
							var pa = {
								c: this.editForm.title,
								k: this.editForm.des,
								i: this.editForm.zimg.length,
								id: this.listData[this.theindex].id
							}
						}
						SubmitTheSchoolAd(pa)
							.then(res => {
								this.loading = false
								if (res) {
									if (this.theindex == -1) {
										this.$message({
											type: 'success',
											message: '添加成功！'
										})
										this.listData.push({
											id: res,
											title: this.editForm.title,
											des: this.editForm.des,
											img: this.editForm.zimg
										})
									} else {
										this.$message({
											type: 'success',
											message: '数据保存成功！'
										})
										this.listData[this.theindex].title = this.editForm.title
										this.listData[this.theindex].des = this.editForm.des
										this.listData[this.theindex].img = this.editForm.zimg
									}
									this.editFormVisible = false
								}
							})
					} else {
						return false
					}
				})
			},
			// 关闭编辑、增加弹出框
			closeDialog() {
				this.editFormVisible = false
			},
			updateInfo() {
				this.$prompt('将更新首页通知', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(({
					value
				}) => {
					UpdateTheHomeInfo({
						i: value
					}).then(res => {
						if (res) {
							this.$message.success('更新成功')
						}
					})
				})
			}
		}
	}
</script>

<style scoped>
	.main-block {
		width: 100%;
		height: 300px;
		border: 1px solid black;
		display: inline-block;
		overflow: auto;
	}

	.main-img {
		width: 100%;

	}

	.clean-img-icon {
		float: right;
		margin: 0 10px 10px 0;
		font-size: 30px;
	}
</style>


// WEBPACK FOOTER //
// src/views/school/infoSet.vue